import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-distributor',
  template: `
<!--    <ul>-->
<!--    <li><a [routerLink]="['distributor/profile']">Distributor Profile</a></li>-->
<!--    <li><a [routerLink]="['dealer/view']">Dealer View</a></li>-->
<!--    <li><a [routerLink]="['dealer/profile']">Dealer Profile</a></li>-->
<!--    <li><a [routerLink]="['employee/profile']">Employee Profile</a></li>-->
<!--    </ul>-->
<!--    <router-outlet></router-outlet>-->
  `,
  styles: []
})
export class DistributorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/distributor/distributor.component.ts